import { request } from './Request';
import { routes } from '../constants/constant.route';

const API_URL = process.env.VITE_APP_API_URL;

export default class NewFleetService {

  fleetStateData = {};

  static addInviteFleet(obj) {
    return request('POST', `${API_URL}${routes.NEW_FLEET.ADD_INVITE_FLEET}`, null, obj, null);
  }

  static editInviteFleet(obj) {
    return request('POST', `${API_URL}${routes.NEW_FLEET.EDIT_INVITE_FLEET}`, null, obj, null);
  }

  static editBusinessRelatedDetail(obj) {
    return request('POST', `${API_URL}${routes.NEW_FLEET.EDIT_BUSINESS_RELATED_DETAIL}`, null, obj, null);
  }

  static setFleetData(data) {
    if (data && Object.keys(data).length) {
      this.fleetStateData = data;
    }
  }

  static getFleetData() {
    return this.fleetStateData && Object.keys(this.fleetStateData).length > 0 ? this.fleetStateData : {};
  }

  static getAMSM(r) {
    return request('GET', `${API_URL}${routes.NEW_FLEET.GET_SM_AND_SM}?region=${r}`, null, null, null);
  }

  static getDepot(r) {
    return request('GET', `${API_URL}${routes.NEW_FLEET.GET_DEPOT}?region_id=${r}`, null, null, null);
  }

  static getNewFleet(reqData) {
    let query = `?page=${reqData.page}&pageSize=${reqData.pageSize}`;
    if (reqData.q) {
      query += `&q=${reqData.q}`
    }
    return request('GET', `${API_URL}${routes.NEW_FLEET.GET_NEW_FLEET}${query}`, null, null, null);
  }

  static getNewFleetById(id) {
    return request('GET', `${API_URL}${routes.NEW_FLEET.GET_NEW_FLEET_BY_ID}?id=${id}`, null, null, null);
  }

  static inviteFleet(obj) {
    return request('POST', `${API_URL}${routes.NEW_FLEET.INVITE_FLEET_NUMBER}`, null, obj, null);
  }

  static getInvitedFleetByNumber(obj) {
    return request('POST', `${API_URL}${routes.NEW_FLEET.GET_INVITED_FLEET_BY_NUMBER}`, null, obj, null);
  }

  static verifyInvitedFleet(obj, is_prospective = false) {
    return request('POST', `${API_URL}${is_prospective ? routes.NEW_FLEET.UPDATE_PROSPECTIVE_FLEET : routes.NEW_FLEET.VERIFY_INVITE_FLEET}`, null, obj, null);
  }



  static uploadFleetDoc(obj, type) {
    const headers = {
      'content-type': 'multipart/form-data'
    };
    return request('POST', `${API_URL}${routes.NEW_FLEET.UPLOAD_FLEET_DOC}?type=${type}`, null, obj, headers);
  }
  static sapIdExists(sap_id) {
    return request('GET', `${API_URL}${routes.NEW_FLEET.SAP_ID_EXITS}?sap_id=${sap_id}`, null, null, null);
  }
}